import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-20 authBox" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("权限详情")
const _hoisted_3 = {
  class: "sourceTb",
  cellpadding: "0",
  cellspacing: "0",
  border: "0"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "团队"),
  /*#__PURE__*/_createElementVNode("th", null, "资源名称"),
  /*#__PURE__*/_createElementVNode("th", null, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "权限"),
  /*#__PURE__*/_createElementVNode("th", null, "创建时间"),
  /*#__PURE__*/_createElementVNode("th", null, "操作")
], -1)
const _hoisted_5 = { style: {"width":"15%"} }
const _hoisted_6 = { style: {"width":"15%"} }
const _hoisted_7 = { style: {"width":"10%"} }
const _hoisted_8 = { style: {"width":"25%"} }
const _hoisted_9 = { style: {"width":"20%"} }
const _hoisted_10 = { style: {"width":"15%"} }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 保存 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 编 辑 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 删 除 ")
const _hoisted_14 = {
  colspan: "6",
  style: {"text-align":"center"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("添加")


const __default__ = {
  name:"AuthorizationTable"
} 
import {  ref, reactive, watch, toRefs, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { deepClone } from '@/utils/index'
import dayjs from 'dayjs'

import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    sourceTbRowData: null,
    optionsArr: null,
    orgsList: null
  },
  emits: ["dataChange"],
  setup(__props: any, { emit }) {

const props = __props as {
  sourceTbRowData: any,
  optionsArr:any,
  orgsList:Array<any>
}

const {
  // 获取权限类型
  'GET/resources/actions': resourcesActionsApi,
} = Api







let listArr:any=reactive({
  list:[]
})
const optionsArr=ref<any>([])
const privilegesAll=ref<any>({})
// 监听编辑行的数据，并进行数据处理
// 映射资源名
let authTypes: any = reactive({})
let _sourceTb = ref<any[]>([]) 
onBeforeMount(() => {
  // 获取权限类型
  resourcesActionsApi().then((rep) => {
    rep.map((_auth: any) => {
      authTypes[_auth.name] = _auth.description
    })
  })
  // 初始化处理数据
  if(!props.sourceTbRowData.userId && !props.sourceTbRowData.id) return;
  _sourceTb.value = props.sourceTbRowData.privileges.map((_privileges: any) => {

    let target = props.optionsArr.find((item: any) => _privileges.res == item.id )
    if(target){
      _privileges.actionsArr = target ? target.actions : []
    }
    _privileges.isSave=true    

    return _privileges
  })

})

// 设置整个表格的privileges数据，并返回给父组件
const setPrivileges = () =>{
  let tgArr = deepClone(_sourceTb.value).reduce((arr: any, _privileges: any) => {
    if(!_privileges.isSave) return arr;

    if(_privileges.actionsArr) delete _privileges.actionsArr;
    delete _privileges.isSave
    arr.push(_privileges)
    return arr
  }, [])
  emit("dataChange", tgArr)
}
const showName=(key:string)=>{
  return authTypes[key]
}

const showAuthoName=(arr:Array<string>)=>{
  let nameArr=arr.map((el:string)=>{
    return showName(el)
  })
  return nameArr.join(",")
}

// 添加
const addData=()=>{
  _sourceTb.value.push({
    rid: "*",
    orgs: [],
    createdAt: dayjs().format('YYYY-MM-DDTHH:mm:ss'),
  })
}
// 资源选择
const sourceChange=(item:any)=>{
  item.actions = []
  let {actions} = props.optionsArr.find((el:any)=>{
    return el.id==item.res
  })
   item.actionsArr=actions
  //  disabledOptionsArr.value=sourceTb.value.map((el:any)=>{
  //    return el.res
  //  })
}

// 映射资源名
const pointSource=(id:string)=>{
  let target = props.optionsArr.filter((el:any) => el.id == id )
  if(target.length) return target[0].name
  return id
}
// 映射团队名
const pointOrgs=(item:Array<any>)=>{
  if(["*", "Owner", "Member", "Absence"].includes(item[0])) return item[0];
  return props.orgsList.reduce((str: string[], org: any) => {
    if(item.includes(org.id + '')) {
      str.push(org.name)
    }
    return str
  }, []).join('，')
}
// 编辑
const editAuthorization=(item:any)=>{
    item.isSave=false
}
// 删除
const deleteAuthorization=(idx:number)=>{
  _sourceTb.value.splice(idx,1)  
  setPrivileges()
  //   disabledOptionsArr.value=sourceTb.value.map((el:any)=>{
  //       return el.res
  //  })
}
// 保存
const saveAuthorize=(item:any)=>{
  item.rid=item.rid||'*'
  if(!(/^[a-zA-Z0-9\*]*$/.test(item.id))){
    ElMessage.error('Id只能是字母数字或者*')
    return
  }
  item.isSave=true  
  setPrivileges()
 }

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_divider, { "content-position": "left" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("table", _hoisted_3, [
      _hoisted_4,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(_sourceTb), (item, idx) => {
        return (_openBlock(), _createElementBlock("tr", { key: idx }, [
          _createElementVNode("td", _hoisted_5, [
            (item.isSave?false:true)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: item.orgs,
                  "onUpdate:modelValue": ($event: any) => ((item.orgs) = $event),
                  filterable: "",
                  multiple: "",
                  "collapse-tags": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option_group, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "All",
                          value: "*",
                          disabled: !item.orgs.includes('*')&&item.orgs.length>=1
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_el_option, {
                          label: "Owner",
                          value: "Owner",
                          disabled: !item.orgs.includes('Owner')&&item.orgs.length>=1
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_el_option, {
                          label: "Member",
                          value: "Member",
                          disabled: !item.orgs.includes('Member')&&item.orgs.length>=1
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_el_option, {
                          label: "Absence",
                          value: "Absence",
                          disabled: !item.orgs.includes('Absence')&&item.orgs.length>=1
                        }, null, 8, ["disabled"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_option_group, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orgsList, (_item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: _item.id,
                            label: _item.name,
                            value: _item.id.toString(),
                            disabled: item.orgs.includes('*')||item.orgs.includes('Owner')||item.orgs.includes('Member')||item.orgs.includes('Absence')
                          }, null, 8, ["label", "value", "disabled"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(pointOrgs(item.orgs)), 1)
                ], 64))
          ]),
          _createElementVNode("td", _hoisted_6, [
            (item.isSave?false:true)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: item.res,
                  "onUpdate:modelValue": ($event: any) => ((item.res) = $event),
                  filterable: "",
                  onChange: ($event: any) => (sourceChange(item))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.optionsArr, (_item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: _item.id,
                        label: _item.name,
                        value: _item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(pointSource(item.res)), 1)
                ], 64))
          ]),
          _createElementVNode("td", _hoisted_7, [
            (item.isSave?false:true)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: item.rid,
                  "onUpdate:modelValue": ($event: any) => ((item.rid) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(item.rid), 1)
                ], 64))
          ]),
          _createElementVNode("td", _hoisted_8, [
            (item.isSave?false:true)
              ? (_openBlock(), _createBlock(_component_el_checkbox_group, {
                  key: 0,
                  modelValue: item.actions,
                  "onUpdate:modelValue": ($event: any) => ((item.actions) = $event)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.actionsArr, (el, idx) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        key: idx,
                        label: el
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(showName(el)), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(showAuthoName(item.actions)), 1)
                ], 64))
          ]),
          _createElementVNode("td", _hoisted_9, _toDisplayString(item.createdAt ? _unref(dayjs)(item.createdAt).format('YYYY-MM-DD') : ''), 1),
          _createElementVNode("td", _hoisted_10, [
            (item.isSave?false:true)
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  disabled: !item.res||!item.orgs.length,
                  onClick: ($event: any) => (saveAuthorize(item))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_link, {
                    onClick: ($event: any) => (editAuthorization(item))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_link, {
                    type: "danger",
                    onClick: ($event: any) => (deleteAuthorization(idx))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ], 64))
          ])
        ]))
      }), 128)),
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_14, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: addData,
            class: "mt-10 mb-10"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})